import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import Popper from 'popper.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import ArrheniusNarrativeMode from './ArrheniusNarrative.js';

import './Template.css';
import './Model.css';
import './index.css';

ReactDOM.render(
  <ArrheniusNarrativeMode/>
, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js